import React from 'react';

// Types
type SidebarActionType = 'OPEN_SIDEBAR' | 'CLOSE_SIDEBAR' | 'TOGGLE_SIDEBAR';
type SidebarAction = { type: SidebarActionType; payload?: boolean };

type SidebarDispatch = (action: SidebarAction) => void;
type SidebarState = {
  open: boolean;
};

const SidebarStateContext = React.createContext<SidebarState | undefined>(undefined);
const SidebarDispatchContext = React.createContext<SidebarDispatch | undefined>(undefined);

const initialState = {
  open: false,
};

const sidebarReducer = (state: SidebarState, action: SidebarAction) => {
  switch (action.type) {
    case 'OPEN_SIDEBAR':
      return { open: true };
    case 'CLOSE_SIDEBAR':
      return { open: false };
    case 'TOGGLE_SIDEBAR':
      return { open: !state.open };
    default:
      return state;
  }
};

export const SidebarProvider: React.FC = ({ children }: any) => {
  const [state, dispatch] = React.useReducer(sidebarReducer, initialState);

  return (
    <SidebarStateContext.Provider value={state}>
      <SidebarDispatchContext.Provider value={dispatch}>{children}</SidebarDispatchContext.Provider>
    </SidebarStateContext.Provider>
  );
};

export const useSidebarState = () => {
  const context = React.useContext(SidebarStateContext);
  if (context === undefined) {
    throw new Error('useSidebarState must be used within a SidebarProvider');
  }
  return context;
};

export const useSidebarDispatch = () => {
  const context = React.useContext(SidebarDispatchContext);
  if (context === undefined) {
    throw new Error('useSidebarDispatch must be used within a SidebarProvider');
  }
  return context;
};
